import React from 'react';
import ClassNames from 'classnames';
import Template from './text-input.rt';
import Styles from './../inputs.less';
import ValidationMixin from 'validations/validation-mixin'

var TextInput = React.createClass({
  propTypes: {
    value: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    tabIndex: React.PropTypes.number,
    autoFocus: React.PropTypes.bool,
    placeholder: React.PropTypes.string,
    className: React.PropTypes.string,
    onKeyUp: React.PropTypes.func,
    onChange: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    isNotValid: React.PropTypes.bool
  },
  getInitialState: function () {
    return {
      value: this.props.value
    };
  },
  handleChange(e){
    this.props.onChange && this.props.onChange(e, e.target.value);
  },
  getClass() {
    return ClassNames(
      Styles.input,
      {
        disabled: this.props.disabled
      },
      this.props.className);
  },
  render: Template
});

module.exports = ValidationMixin(TextInput);


/** WEBPACK FOOTER **
 ** ./src/form-controls/inputs/text-input/index.js
 **/